import api from "./api"
import { getStoredShipper } from "../../src/constants/utils"

const userViewsApi = {
    getUserViews() {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.get(
            `user-views/corporations/${STORED_RAILROAD_NAME_ENCODED}/roads/${STORED_RAILROAD_NAME_ENCODED}/shippers/${STORED_SHIPPER_NAME_ENCODED}/views`,
            "ROOT"
        )
    },

    saveUserView({
        Name,
        viewOrder,
        isDefault,
        description,
        type,
        accessType,
        data,
    }) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.post(
            `user-views/corporations/${STORED_RAILROAD_NAME_ENCODED}/roads/${STORED_RAILROAD_NAME_ENCODED}/shippers/${STORED_SHIPPER_NAME_ENCODED}/views`,
            {
                name: Name,
                viewOrder: viewOrder,
                default: isDefault,
                description: description,
                type: type,
                accessType: accessType,
                data: data,
            },
            "ROOT"
        )
    },

    updateUserView({ Name, isDefault, description, accessType, data }) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.put(
            `user-views/corporations/${STORED_RAILROAD_NAME_ENCODED}/roads/${STORED_RAILROAD_NAME_ENCODED}/shippers/${STORED_SHIPPER_NAME_ENCODED}/views?view=${encodeURIComponent(Name)}`,
            {
                name: Name,
                default: isDefault,
                description: description,
                accessType: accessType,
                data: data,
            },
            "ROOT"
        )
    },

    deleteUserView({ name }) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.delete(
            `user-views/corporations/${STORED_RAILROAD_NAME_ENCODED}/roads/${STORED_RAILROAD_NAME_ENCODED}/shippers/${STORED_SHIPPER_NAME_ENCODED}/views?view=${encodeURIComponent(name)}`,
            "ROOT"
        )
    },
}

export default userViewsApi
